import { ElementType, ReactNode } from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal';

interface RevealProps {
  children: ReactNode;
  /** Stagger delay in ms before the element animates in. */
  delay?: number;
  /** IntersectionObserver threshold (0-1). */
  threshold?: number;
  className?: string;
  /** Element/tag to render. Defaults to a div. */
  as?: ElementType;
}

/**
 * Lightweight wrapper that fades + lifts its children into view on scroll.
 * Built on the shared useScrollReveal hook (respects prefers-reduced-motion).
 */
export function Reveal({
  children,
  delay = 0,
  threshold = 0.15,
  className,
  as: Tag = 'div',
}: RevealProps) {
  const ref = useScrollReveal<HTMLElement>({ delay, threshold });
  return (
    <Tag ref={ref} className={className}>
      {children}
    </Tag>
  );
}
